var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmotion1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8476_3687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9531 79.9375C62.0445 79.9375 79.9531 62.0289 79.9531 39.9375C79.9531 17.8461 62.0445 -0.0625 39.9531 -0.0625C17.8617 -0.0625 -0.046875 17.8461 -0.046875 39.9375C-0.046875 62.0289 17.8617 79.9375 39.9531 79.9375Z",
    fill: "url(#paint0_radial_8476_3687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7813 37.5625C57.3787 37.5625 59.4844 34.6104 59.4844 30.9687C59.4844 27.3271 57.3787 24.375 54.7813 24.375C52.1838 24.375 50.0781 27.3271 50.0781 30.9687C50.0781 34.6104 52.1838 37.5625 54.7813 37.5625Z",
    fill: "url(#paint1_radial_8476_3687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1094 37.5625C27.7068 37.5625 29.8125 34.6104 29.8125 30.9687C29.8125 27.3271 27.7068 24.375 25.1094 24.375C22.5119 24.375 20.4062 27.3271 20.4062 30.9687C20.4062 34.6104 22.5119 37.5625 25.1094 37.5625Z",
    fill: "url(#paint2_radial_8476_3687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4844 62.7188C20.1407 62.7188 19.8125 62.5781 19.5625 62.3125C19.0938 61.7969 19.1407 61.0156 19.6407 60.5469C24.5313 56.0938 29.7188 53.3125 35.0625 52.2969C39.3594 51.4688 43.75 51.7813 48.1094 53.2188C55.4688 55.6406 60.125 60.3906 60.3125 60.5938C60.7969 61.0938 60.7813 61.875 60.2813 62.3594C59.7813 62.8438 59 62.8281 58.5157 62.3281C58.4219 62.2344 54 57.75 47.2344 55.5625C38.2344 52.6406 29.5157 54.9375 21.3282 62.3906C21.0782 62.625 20.7813 62.7188 20.4844 62.7188Z",
    fill: "url(#paint3_linear_8476_3687)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8476_3687",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9463 39.93) scale(42.6073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFEA7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#FFE273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#FFD361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFBF48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FFA629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#FF8804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#FF9C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    stopColor: "#FFB53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#FFD766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED81"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8476_3687",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.7867 30.9821) scale(5.0975 7.22316)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#7A3F1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#7E421C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#884D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#9B5E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#B4762D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C68632"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8476_3687",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.1059 30.9821) scale(5.0975 7.22316)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#7A3F1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#7E421C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#884D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#9B5E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#B4762D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C68632"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8476_3687",
    x1: 39.9463,
    y1: 50.0911,
    x2: 39.9463,
    y2: 63.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#985B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A3F1B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8476_3687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotion1);
export default __webpack_public_path__ + "static/media/emotion1.882cdc2e59b54da5e4d89307da74680b.svg";
export { ForwardRef as ReactComponent };